module.exports = __webpack_public_path__ + "img/HA1503-76.32415711.jpg";